import { appointmentSchedule, getAppointmentSlots, getCatalogueAMCList, getLiveTracking, getServiceRequestCatalogueVersionTwo, getServiceRequestDetails, getServiceRequestsEligibiltyVersionTwo } from '@/services/apiService.service';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

type Catalogue = {
  subcatProbcode: Record<string, string[]>;
  probcodeIncident: Record<string, string[]>;
  catSubcat: Record<string, string[]>;
};
interface ServiceRequestState {
  allCatalogue:Catalogue; 
  subcategories: Record<string, string[]>;
  incidents: Record<string, string[]>;
  loading: boolean;
  error: string | null;
  eligibility:  Record<string, string[]>;
  category:  Record<string, string[]>;
  appointmentSlots:  Record<string, string[]>;
  serviceRequestDetails: Record<string, string[]>;
  selectedProperty: { orderId: string; unitId: string } | null;
  liveTracking: Record<string, string[]>;
  eligibleProperties:Record<string, string[]>;
  amcList:string[];
  canRescheduleSR:boolean;
}

const initialState: ServiceRequestState = {
  allCatalogue:{
    catSubcat:{},
    subcatProbcode: {},
    probcodeIncident: {}
  },
  subcategories: {},
  incidents: {},
  loading: false,
  error: null,
  eligibility: {}, // Initialize eligibility
  category: {},
  appointmentSlots: {},
  serviceRequestDetails: {},
  selectedProperty: null,
  eligibleProperties:{},
  liveTracking:{},
  amcList:[],
  canRescheduleSR:true,
};

export const fetchCatalogue = createAsyncThunk(
  'newServiceRequest/fetchCatalogue',
  async ({ customerId }: { customerId: string }) => {
    const response = await getServiceRequestCatalogueVersionTwo({ customerId, });
    return response.data;
  }
);


export const fetchEligibility = createAsyncThunk(
  'newServiceRequest/fetchEligibility',
  async ({ customerId, referenceId }: { customerId: any, referenceId: any }) => {
    const response = await getServiceRequestsEligibiltyVersionTwo({ customerId, orderId: '', requestType: 'DLP', referenceId });
    return response;
  }
);

export const fetchAppointmentSlots = createAsyncThunk(
  'newServiceRequest/fetchAppointmentSlots',
  
  async (payload:any) => {
    const response = await getAppointmentSlots(payload);
    return response; // Return the data property directly
  }
);

export const scheduleAppointment = createAsyncThunk(
  'newServiceRequest/scheduleAppointment',
  async (payload:any) => {
    const response = await appointmentSchedule(payload);
    return response; // Return the data property directly
  }
);

export const fetchServiceRequestDetails = createAsyncThunk(
  'newServiceRequest/fetchServiceRequestDetails',
  async (payload:any) => {
    const response = await getServiceRequestDetails(payload);
    return response; // Return the data property directly
  }
);

export const fetchliveTracking = createAsyncThunk(
  'newServiceRequest/fetchliveTracking ',
  async (payload:any) => {
    const response = await getLiveTracking(payload);
    return response; // Return the data property directly
  }
);

export const getAmcList = createAsyncThunk(
  'newServiceRequest/fetchAmcList',
  async (payload:any) => {
    const response = await getCatalogueAMCList(payload);
    return response; // Return the data property directly
  }
);

const newServiceRequestSlice = createSlice({
  name: 'newServiceRequest',
  initialState,
  reducers: {
    setSelectedProperty: (state, action) => { 
      state.selectedProperty = action.payload;
    },
    clearSelectedProperty: (state) => { 
      state.selectedProperty = null;
    },
    setEligibleProperties:(state, action) => { 
      state.eligibleProperties = action.payload;
    },
    resetNewServiceRequest: () => {
      return initialState
    }
 
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCatalogue.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCatalogue.fulfilled, (state, action) => {
        state.loading = false;  
        state.allCatalogue=action.payload?.data||{};
        state.subcategories = {
          ...(action.payload?.data?.subcatProbcode || {}),
          other: action.payload?.data?.other || {},
        };
        state.incidents = action.payload?.data?.probcodeIncident || {};
        state.category = action.payload?.data?.catSubcat || {};
      })
      .addCase(fetchCatalogue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch catalogue';
      })
      .addCase(fetchEligibility.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEligibility.fulfilled, (state, action) => {
        state.loading = false;
        state.eligibility = action?.payload?.data; // Store the eligibility data
        state.canRescheduleSR=action?.payload?.canRescheduleSR;
      })
      .addCase(fetchEligibility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch eligibility';
      })
      .addCase(fetchAppointmentSlots.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAppointmentSlots.fulfilled, (state, action) => {
        state.appointmentSlots = {};
        state.loading = false;
        state.appointmentSlots = action.payload|| {};
      })
      .addCase(fetchAppointmentSlots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch Appointment slots';
      })
      .addCase(fetchServiceRequestDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchServiceRequestDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.serviceRequestDetails = action.payload|| {};
      })
      .addCase(fetchServiceRequestDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch Request Details';
      })
      .addCase(fetchliveTracking.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchliveTracking.fulfilled, (state, action) => {
        state.loading = false;
        state.liveTracking  = action.payload|| {};
      })
      .addCase(fetchliveTracking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to Live Tracking Details';
      })
      .addCase(getAmcList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAmcList.fulfilled, (state, action) => {
        state.loading = false;  
        state.amcList  = action.payload|| {};
      })
      .addCase(getAmcList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch catalogue';
      });
  },
});
export const { setSelectedProperty, clearSelectedProperty, setEligibleProperties, resetNewServiceRequest } = newServiceRequestSlice.actions;
export default newServiceRequestSlice.reducer;
